export default __webpack_public_path__ + "static/media/justpayto-philippines-payments-2.43d060ec.jpg";